<!-- COLORS -->
<div class="product-options d-flex align-items-center my-3" *ngIf="uniqueColors?.length">
    <div class="color-wrapper tooltip-container" *ngFor="let c of uniqueColors"
        [class.active]="c.color_key === selectedColorKey" [class.disabled]="!availableColors.includes(c.color_key)"
        (click)="selectColor(c)">
        <img class="option-img" [src]="cdnImagePath + c.color_chip_img" [alt]="c.color" [title]="c.color" />
        <span class="custom-tooltip top">
            <img class="tooltip-img" [src]="cdnImagePath + c.color_chip_img" [alt]="c.color" />
            <span class="tooltip-text">{{ c.color }}</span>
        </span>
    </div>
</div>

<!-- SIZES -->
<div class="product-options d-flex align-items-center product-size-options my-3" *ngIf="uniqueSizes?.length">
    <div class="size-wrapper" *ngFor="let s of uniqueSizes" [class.active]="s.size_key === selectedSizeKey"
        [class.disabled]="!availableSizes.includes(s.size_key)" (click)="selectSize(s)">
        <span class="size-box">{{ s.size }}</span>
    </div>
</div>